import TextField from '@sdk/components/forms/TextField';
import gettext from '@sdk/lang/gettext';

import { FieldWrapper } from '@web/conversations/ComposeConversation/composeConversation.styles';
import { NameField } from '@web/conversations/types/ConversationFields';

const CONVERSATION_NAME_MAX_LENGTH = 128;

type Props = {
  name: NameField;
};

export const ConversationNameField = ({ name }: Props) => (
  <FieldWrapper>
    <TextField
      id="conversation-name"
      value={name.value}
      onChange={name.onChange}
      onBlur={name.onBlur}
      placeholder={gettext('Name this conversation')}
      maxLength={CONVERSATION_NAME_MAX_LENGTH}
      label={gettext('conversation name')}
    />
  </FieldWrapper>
);
